import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApi } from '../api-context';
import { queryKeys } from '../query-keys';
import { meSchema, type Me, type OnboardingInput } from '../schemas';

/**
 * Fin de l'onboarding : nom du cabinet et effectif. Réservé à l'admin du
 * cabinet. Marque `onboardingFait` sur l'utilisateur, c'est cet indicateur,
 * et non le localStorage, qui décide de réafficher le parcours.
 */
export function useCompleteOnboarding() {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: OnboardingInput) =>
      api.post<Me>('/cabinets/onboarding', input, { schema: meSchema }),
    onSuccess: (data) => queryClient.setQueryData(queryKeys.auth.me(), data),
  });
}
